(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-responsive"] && !window.DesignMode) return;
  try {
    
  class VideoResponsive
  {
      
      currentFormat;
      player;
      wrapper;
      sound;
      muted = true;
      
      sources = {};
      
      constructor(selector)
      {
          this.player = document.querySelector(selector);
          this.wrapper = this.player.parentNode;
          this.sound = this.wrapper.querySelector(".sound-icon");
          this.sources.landscape = this.player.dataset.videoDesktop;
          this.sources.portrait = this.player.dataset.videoMobile;
          
          this.currentFormat = null;
          this.init();
      }
      
      init()
      {
          var self = this;
          self.resize();
          window.addEventListener("resize", function() {	
              self.resize();
          });
          this.sound.addEventListener("click", function() {
              self.checkSound();
          });
          /*$(window).on("scroll", function() {
            if($(window).scrollTop() < $(window).height()) {
              if(self.player.paused) self.player.play();
            } else {
              if(!self.player.paused) self.player.pause();
            }
          });*/
      }
      
      resize()
      {
          var self = this;
          var format = this.checkFormat();
          if(format != this.currentFormat) {
              this.currentFormat = format;
              console.log("format change:", format);
              if(format == "landscape") {
                  this.wrapper.classList.remove("portrait");
              }else {
                  this.wrapper.classList.remove("landscape");
              }
              this.wrapper.classList.add(format);
              
              var source = this.player.querySelector("source");
              source.setAttribute("src", this.sources[format]);
              setTimeout(function() { 
                self.player.load();
                self.player.play();
              }, 100);
          }
      }
      
      checkFormat()
      {
          if(window.innerWidth >= window.innerHeight) {
              return "landscape";
          }
          return "portrait";
      }
      
      checkSound()
      {
          console.log("checkSound");
          if(this.muted) {
              this.muted = false;
              this.sound.classList.replace("muted", "unmuted");
          } else {
              this.muted = true;
              this.sound.classList.replace("unmuted", "muted");
          }
          this.player.muted = !this.player.muted;
      }
  }
  
  document.addEventListener("DOMContentLoaded", function(event) { 
      let videoResponsive = new VideoResponsive(".video-responsive video");
  });

  } catch(e) { console.error(e); }
})();
})();
